var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"loading":"","max-width":"600px"}},[_c('card-toolbar',{staticClass:"mt-4 mb-3",attrs:{"icon":_vm.DOWNLOAD_ICON,"title":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }